import React, { useContext } from "react";

// Register job type renderers (side-effect import)
import "src/experiences/cluster-experience/common/flat-file-importer/registerImportJobTypes";
import { UserContext } from "src/contexts/UserContext";
import ImpersonationIndicator from "src/experiences/cluster-experience/context-switcher/ImpersonationIndicator";
import { HotkeyProvider } from "src/hotkeys";

import Loader from "./components/common/Loader";
import VersionChecker from "./components/VersionChecker";
import CustomIntercomLauncher from "./DraggableIntercomLauncher";
import IntercomLauncher from "./IntercomLauncher";
import useUser from "./hooks/useUser";
import NotistackProvider from "./providers/NotistackProvider";
import RootRoutes from "./RootRoutes";
import ThemeConfig from "./theme";

export default function App(): React.ReactElement {
  const { isUserLoading } = useUser();
  const { isStaff, user } = useContext(UserContext);

  const isProduction = ["production"].includes(
    import.meta.env.VITE_ENVIRONMENT
  );
  const showEnvironmentBorder =
    isProduction && (isStaff || !!user?.impersonatorId);

  return (
    <ThemeConfig>
      <HotkeyProvider>
        <NotistackProvider>
          <VersionChecker />
          {isUserLoading ? <Loader /> : <RootRoutes />}
          {showEnvironmentBorder && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                boxSizing: "border-box",
                pointerEvents: "none",
                zIndex: 9999,
                border: "4px solid #D32F2F",
              }}
            />
          )}
          <ImpersonationIndicator />
          <IntercomLauncher />
          <CustomIntercomLauncher />
        </NotistackProvider>
      </HotkeyProvider>
    </ThemeConfig>
  );
}
